import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { VerificationForm } from '@/components/VerificationForm'
import { ContractLookup } from '@/components/ContractLookup'

function App() {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-8">
        <div className="mb-8 text-center">
          <h1 className="text-4xl font-bold tracking-tight mb-2">
            Integra Verification Platform
          </h1>
          <p className="text-muted-foreground">
            Verify and lookup smart contracts across multiple blockchain networks
          </p>
        </div>

        <Tabs defaultValue="verify" className="w-full max-w-4xl mx-auto">
          <TabsList className="grid w-full grid-cols-2">
            <TabsTrigger value="verify">Verify Contract</TabsTrigger>
            <TabsTrigger value="lookup">Lookup Contract</TabsTrigger>
          </TabsList>

          <TabsContent value="verify" className="mt-6">
            <VerificationForm />
          </TabsContent>

          <TabsContent value="lookup" className="mt-6">
            <ContractLookup />
          </TabsContent>
        </Tabs>

        <footer className="mt-16 text-center text-sm text-muted-foreground">
          <p>Powered by Integra Sourcify</p>
        </footer>
      </div>
    </div>
  )
}

export default App
